// quick jump bar  quick-jump-bar.liquid
class QuickJumpBar extends HTMLElement {
    constructor() {
        super();
        this.items = [];
        this.sticky = false;
        this.eventListener = null;
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.quick-jump-bar-item');
        this.sticky = this.dataset.sticky === "true";

        // this.enableSticky();
        this.attachEvents();
        this.checkMainItem();
        this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            (eventData) => {
                // console.log('Quick jump bar接收到事件发布');

                // 执行原来的 productStatus 方法
                this.productStatus(eventData);
            }
        );

        this.notifyButton();
    }

    notifyButton() {
        const notifyButton = this.querySelector('.quick-jump-bar-item__notify-button');



        // 点击按钮模拟点击Stoq插件提供的按钮, 打开弹窗
        notifyButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (window._RestockRocket && typeof window._RestockRocket.openModal === 'function') {
                window._RestockRocket.openModal();
                console.log('Open RestockRocket Modal Successfully');
            } else {
                console.log('RestockRocket Not Loaded');
            }
        });

        if (!notifyButton) {
            // console.log('Notify button not found');
            return;
        }

        // console.log('Notify button found:', notifyButton);

        const paymentContainer = document.querySelector('.product-form__payment-container');

        if (!paymentContainer) {
            // console.log('.product-form__payment-container not found');
            return;
        }

        // 如果已经存在重连定时器，先清除
        if (this.reconnectTimer) {
            clearInterval(this.reconnectTimer);
        }

        // 设置一个 5 秒的超时定时器
        const timeout = setTimeout(() => {
            clearInterval(this.reconnectTimer); // 清除重连定时器
            console.log('Timeout: #SI_trigger not found within 5 seconds');
        }, 5000);

        // 设置每500检查一次 #SI_trigger 元素
        this.reconnectTimer = setInterval(() => {
            const siTrigger = document.querySelector('#SI_trigger');

            if (siTrigger) {
                this.rebindNotifyButtonClick(notifyButton, siTrigger);
                // console.log('Found SI_trigger:', siTrigger);
                // 找到 #SI_trigger 时，清除重连定时器和超时定时器
                clearInterval(this.reconnectTimer);
                clearTimeout(timeout);

            }
        }, 500);
    }

    rebindNotifyButtonClick(notifyButton, node) {
        notifyButton.removeEventListener('click', this.notifyButtonClickHandler);

        this.notifyButtonClickHandler = () => {
            node.click();
            // console.log('Notify button clicked');
        };

        notifyButton.addEventListener('click', this.notifyButtonClickHandler);
    }

    productStatus({ data: { event, target, selectedOptionValues } }) {
        // console.log("开始更新quick jump Bar");
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        if (!productUrl) {
            // console.error('未找到产品的 URL');
            return; // 如果没有有效的产品 URL，则直接返回
        }

        // 构建请求参数
        const params = [`section_id=${this.sectionId}`];

        // 如果 selectedOptionValues 存在且有选项值，则加入参数
        if (Array.isArray(selectedOptionValues) && selectedOptionValues.length > 0) {
            params.push(`option_values=${selectedOptionValues.join(',')}`);
        }

        // 构建最终的请求 URL
        const buildRequestUrl = `${productUrl}?${params.join('&')}`;
        // console.log('请求的 URL:', buildRequestUrl);

        // 使用 fetch 请求获取该 URL 的 HTML 内容
        fetch(buildRequestUrl)
            .then((response) => {
                if (!response.ok) {
                    // throw new Error('请求失败：' + response.statusText);
                }
                return response.text(); // 获取响应文本
            })
            .then((responseText) => {
                try {
                    // 使用 DOMParser 将响应文本解析为 HTML 文档
                    const html = new DOMParser().parseFromString(responseText, 'text/html');

                    // 获取返回的 HTML 中的目标元素
                    const id = 'quick-jump-bar'; // 我们需要查找的元素 ID 前缀
                    const source = html.getElementById(`${id}-${this.sectionId}`); // 查找对应 sectionId 的元素
                    const destination = this; // 当前实例，即目标元素

                    if (source && destination) {
                        // console.log("Quick Jump Bar HTML updated 开始");
                        if (this.eventListener) {
                            document.removeEventListener(PUB_SUB_EVENTS.updateProductInfo, this.eventListener);
                        }

                        // 订阅自定义事件 update-product-info
                        this.eventListener = (event) => {
                            destination.innerHTML = source.innerHTML;

                            // 重新绑定通知按钮
                            setTimeout(() => {
                                // console.log("重新绑定通知按钮");
                                this.notifyButton();
                            }, 500);
                        };

                        document.addEventListener(PUB_SUB_EVENTS.updateProductInfo, this.eventListener);
                    } else {
                        // console.warn(`未能找到 ID 为 ${id}-${this.sectionId} 的元素`);
                    }
                } catch (error) {
                    // console.error('HTML 解析错误:', error);
                }
            })
            .catch((error) => {
                // console.error('请求或解析错误:', error);
            });
    }

    get sectionId() {
        return this.dataset.section; // 返回当前组件的 sectionId，通常是数据属性
    }

    // enableSticky() {
    //     if (this.sticky) {
    //         document.body.classList.add('header_no_sticky');
    //     }
    // }

    // inTheArea() {
    //     const viewportCenter = window.innerHeight / 2 + window.scrollY;

    //     this.items.forEach(item => {
    //         const targetId = item.getAttribute('data-target-id');
    //         const targetElement = document.querySelector(`[data-jump-id="${targetId}"]`);
    //         if (targetElement) {

    //             const rect = targetElement.getBoundingClientRect();
    //             const top = rect.top + window.scrollY;
    //             const bottom = rect.bottom + window.scrollY;

    //             if (viewportCenter >= top && viewportCenter <= bottom) {
    //                 item.classList.add('active');
    //             } else {
    //                 item.classList.remove('active');
    //             }
    //         }
    //     });
    // }

    jumpTo(event) {
        const targetId = event.currentTarget.getAttribute('data-target-id');
        // 获取 data-jump-id 属性和 targetId 相等的元素
        const targetElement = document.querySelector(`[data-jump-id="${targetId}"]`);

        if (!targetElement) {
            return; // 如果目标元素不存在，则直接返回
        }
        // 移除所有项的 active 类
        this.items.forEach(item => item.classList.remove('active'));

        // 给点击的项添加 active 类
        event.currentTarget.classList.add('active');

        // 计算滚动位置，减去 sticky 元素的总高度
        const offsetTop = targetElement.offsetTop - this.checkStickyElements();
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });

        this.scrollItemToCenter(event.currentTarget); // 滚动项居中
    }

    checkStickyElements() {
        const header = document.querySelector('.section-header');
        const headerSticky = header ? header.classList.contains('shopify-section-header-sticky') : false;
        let stickyElementsHeight = 0;

        // 如果 this.sticky 为真，则加上 offsetHeight
        if (this.sticky) {
            stickyElementsHeight += this.offsetHeight;
        }

        // 如果 headerSticky 为真，则加上 header 的高度
        if (headerSticky) {
            stickyElementsHeight += header.offsetHeight;
        }
        return stickyElementsHeight; // 返回所有需要减去的高度
    }

    scrollItemToCenter(item) {
        const wrapper = this.querySelector('.quick-jump-items');
        const wrapperRect = wrapper.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const wrapperScrollLeft = wrapper.scrollLeft;

        const offsetLeft = itemRect.left - wrapperRect.left + wrapperScrollLeft - (wrapperRect.width / 2) + (itemRect.width / 2);

        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    attachEvents() {
        this.items.forEach(item => {
            item.addEventListener('click', this.jumpTo.bind(this));
        });

        // window.addEventListener('scroll', this.inTheArea.bind(this));
    }

    checkMainItem() {
        // 使用 setTimeout 延迟执行
        setTimeout(() => {
            const hasMainItem = Array.from(this.items).some(item => {
                const isMainItem = item.getAttribute('data-main-item') === "true";
                if (isMainItem) {
                    const targetId = item.getAttribute('data-target-id');
                    const targetElement = document.querySelector(`[data-jump-id="${targetId}"]`);
                    if (targetElement) {
                        // console.log(targetElement);
                        return true;
                    }
                }
                return false;
            });

            if (!hasMainItem) {
                // 如果没有主项目，什么也不做
            } else {
                this.checkJumpItems();
                this.classList.add('active');
            }
        }, 1000); // 延迟 1 秒 ， 因产品页面的section需要判断生成
    }

    checkJumpItems() {
        this.items.forEach(item => {
            const targetId = item.getAttribute('data-target-id');
            const targetElement = document.querySelector(`[data-jump-id="${targetId}"]`);

            if (!targetElement) {
                item.setAttribute('data-target-not-found', 'true');
            }
        });
    }

}

customElements.define('quick-jump-bar', QuickJumpBar);
